module.exports = __webpack_public_path__ + "static/2-9b6baeb1abbf390155958e70db3a9640.jpg";